// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__8ygkg","container":"styles_container__mdQJy","title":"styles_title__1DmBT","wrapper":"styles_wrapper__3aB-R","answer":"styles_answer__3u7qD"};